import React from 'react';
import '../../pages/style.css';
import Typewriter from 'typewriter-effect';

function Text() {
  return (
    <Typewriter
      options={{
        strings: ['React Js Full Stack Developer', 'SOC Analyst', '3D Animator'],
        autoStart: true,
        loop: true,
        deleteSpeed: 100,
      }}
    />
  );
}

export default Text;
